/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloProveedores from 'Infotrack@Modelos/smartStock/proveedores';
import IProveedores from 'Infotrack@Modelos/smartStock/proveedores/entidades/proveedores';

export default class ControladorModeloProveedores {
    private modeloProveedores: ModeloProveedores;
    constructor() {
        this.modeloProveedores = new ModeloProveedores();
    }

    public consultarProveedores() {
        return this.modeloProveedores.consultarProveedores().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearProveedores(proveedores: IProveedores) {
        await this.modeloProveedores.crearProveedores(proveedores);
    }

    public async editarProveedores(proveedores: IProveedores) {
        await this.modeloProveedores.editarProveedores(proveedores);
    }

    public async eliminarProveedores(proveedores: IProveedores) {
        await this.modeloProveedores.eliminarProveedores(proveedores);
    }

    public async consultarListaProveedoresPorEmpresaId(EmpresaId: string) {
        return this.modeloProveedores.consultarListaProveedoresPorFiltro({EmpresaId}).then(({ data: { Entidades } }) => Entidades);
    }

    public validarEntidad(proveedores: IProveedores): boolean {
        if (proveedores.DescripcionProveedor === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
